import { StatCardTone } from './StatCardTone';

type StatCardProps = {
  label: string;
  value: string;
  hint?: string;
  tone?: StatCardTone;
};

const TONE_STYLES: Record<
  StatCardTone,
  { card: string; label: string; value: string; hint: string }
> = {
  primary: {
    card: 'border-primary-200 bg-primary-50',
    label: 'text-primary-700',
    value: 'text-primary-800',
    hint: 'text-primary-600',
  },
  sky: {
    card: 'border-sky-200 bg-sky-50',
    label: 'text-sky-700',
    value: 'text-sky-900',
    hint: 'text-sky-600',
  },
  emerald: {
    card: 'border-emerald-200 bg-emerald-50',
    label: 'text-emerald-700',
    value: 'text-emerald-900',
    hint: 'text-emerald-600',
  },
  violet: {
    card: 'border-violet-200 bg-violet-50',
    label: 'text-violet-700',
    value: 'text-violet-900',
    hint: 'text-violet-600',
  },
  amber: {
    card: 'border-amber-200 bg-amber-50',
    label: 'text-amber-800',
    value: 'text-amber-900',
    hint: 'text-amber-700',
  },
  rose: {
    card: 'border-rose-200 bg-rose-50',
    label: 'text-rose-700',
    value: 'text-rose-900',
    hint: 'text-rose-600',
  },
  teal: {
    card: 'border-teal-200 bg-teal-50',
    label: 'text-teal-700',
    value: 'text-teal-900',
    hint: 'text-teal-600',
  },
  indigo: {
    card: 'border-indigo-200 bg-indigo-50',
    label: 'text-indigo-700',
    value: 'text-indigo-900',
    hint: 'text-indigo-600',
  },
  orange: {
    card: 'border-orange-200 bg-orange-50',
    label: 'text-orange-700',
    value: 'text-orange-900',
    hint: 'text-orange-600',
  },
};

export function StatCard({ label, value, hint, tone = 'primary' }: StatCardProps) {
  const styles = TONE_STYLES[tone];

  return (
    <article className={`rounded-xl border p-5 shadow-sm ${styles.card}`}>
      <p className={`text-xs font-semibold uppercase tracking-wide ${styles.label}`}>{label}</p>
      <p className={`mt-2 text-2xl font-bold ${styles.value}`}>{value}</p>
      {hint ? <p className={`mt-1 text-sm ${styles.hint}`}>{hint}</p> : null}
    </article>
  );
}
